import { styled } from "styled-components";

export const FeaturesSectionWrapper = styled.div<{ $altBackground?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 96px 40px;
  gap: 24px;
  background: ${({ theme, $altBackground }) =>
    $altBackground ? theme.colors.default[50] : "transparent"};
`;

export const FeaturesSectionContainer = styled.div<{ $column: boolean }>`
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  display: flex;
  flex-direction: ${({ $column }) => ($column ? "column" : "row")};
  align-items: ${({ $column }) => ($column ? "center" : "flex-start")};
  gap: 64px;

  ${({ theme }) => theme.breakpoints.lg.query} {
    flex-direction: column;
    align-items: center;
  }
`;
export const FeaturesTextContainer = styled.div<{ $column: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $column }) => ($column ? "center" : "flex-start")};
  gap: 12px;
  width: ${({ $column }) => ($column ? "100%" : "364px")};
  text-align: ${({ $column }) => ($column ? "center" : "left")};
  max-width: 925px;

  ${({ theme }) => theme.breakpoints.lg.query} {
    width: 100%;
    align-items: center;
    text-align: center;
  }
`;

export const FeaturesSectionSubHeading = styled.div`
  color: ${({ theme }) => theme.colors.default[600]};

  & a {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const FeaturesSectionHeading = styled.div`
  color: ${({ theme }) => theme.colors.default[900]};
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 32px */
  letter-spacing: 0.96px;
`;

export const FeaturesContentContainer = styled.div<{ $column: boolean }>`
  display: flex;
  min-height: 120px;
  height: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  gap: 64px 32px;
  align-self: stretch;
  flex-wrap: wrap;
  width: ${({ $column }) => ($column ? "100%" : "calc(100% - 364px)")};

  ${({ theme }) => theme.breakpoints.lg.query} {
    width: 100%;
    justify-content: center;
  }

  > div {
    height: 100%;
    > div:first-of-type {
      svg {
        height: 30px;
        width: 30px;
      }
    }
  }
`;
